import { render, staticRenderFns } from "./KitsPage.vue?vue&type=template&id=6c5ded8d"
import script from "./KitsPage.vue?vue&type=script&lang=js"
export * from "./KitsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports